module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-2abe4371.png";